import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logger } from 'projects/common/src/app/classes';
import { CacheService } from 'projects/common/src/app/services';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserDataService } from 'src/app/modules/core/services/parameter';
import { CommunicationService } from 'src/app/services/communication';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ProductionByTypetruckService extends Logger {
  private baseUrl: string;

  constructor(
    private userData: UserDataService,
    private communicationService: CommunicationService,
    private cacheService: CacheService,
    private urlBuilderService: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilderService.serverBasePath;
  }

  /**
   * Function to get loop detail
   * @param inputDate
   * @param shiftId
   */
  public getLoopsByMachineModelAndExtractionPointDetail(inputDate: string, shiftId: number, streetId: number): Promise<any> {
    const params = this.setParams(inputDate, shiftId, streetId.toString());
    const url = `${this.baseUrl}/Production/GetLoopsByMachineModelAndExtractionPointDetail`;
    return this.communicationService
      .get(url, params)
      .pipe(catchError((err) => this.handleError(err)))
      .toPromise();
  }

  /**
   * Handle error
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    this.error(err);
    return throwError(err);
  }

  /**
   * Function to set params to build query
   * @param inputDate Input date to get loops
   * @param shiftId Shift ID to get loops
   */
  private setParams(inputDate: string, shiftId: number, streetId?: string): HttpParams {
    let paramsObj = {};

    if (streetId) {
      paramsObj = {
        fromObject: {
          inputDate,
          shiftId: shiftId.toString(),
          companyId: this.getUserCompany(),
          zoneId: streetId,
        },
      };
    } else {
      paramsObj = {
        fromObject: {
          inputDate,
          shiftId: shiftId.toString(),
          companyId: this.getUserCompany(),
        },
      };
    }

    return new HttpParams(paramsObj);
  }
  /**
   * Function to get user company ID
   */
  public getUserCompany(): string {
    return (this.userData.company() ? this.userData.company().id : 0).toString();
  }
}
